/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid } from '@material-ui/core';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { FormikTextField } from 'modules/Common';
import { TestSessionInstrumentDto } from 'modules/InstrumentsQualityControl/models';
import SignOffDialog from '../SignOffDialog/SignOffDialog';

export default function InstrumentTestConfirmDialog({
  open = false,
  setOpen,
  onSubmit,
  setCurrent,
  title,
  initialValues = {},
  ...props
}: { test?: TestSessionInstrumentDto | null } & Record<string, any>) {
  const dialogTitle = <>{title}</>;
  return (
    <>
      <Formik
        onSubmit={data => {
          return new Promise((resolve, reject) => {
            onSubmit({
              ...data,
            }).then(response => {
              setOpen(false);
              setCurrent(response);

              resolve(response);
            }, reject);
          });
        }}
        enableReinitialize
        validationSchema={yup.object({
          comment: yup.string().required(),
        })}
        initialValues={{
          ...initialValues,
        }}
      >
        {form => {
          async function onSign() {
            await form.submitForm();
          }

          return (
            <SignOffDialog
              open={open}
              onSign={onSign}
              title={dialogTitle}
              onClose={() => {
                setOpen(false);
              }}
              buttonText="Save"
              {...props}
            >
              <Grid item xs>
                <Form>
                  <FormikTextField label="Comment" name="comment" />
                </Form>
              </Grid>
            </SignOffDialog>
          );
        }}
      </Formik>
    </>
  );
}
